
























	import Vue from 'vue';
    import ListRaidComp from './ListRaidComp.vue';
    import _raids from '../../services/endpoints/raids';
	import { userRaid } from 'models/Types';

    export default Vue.extend({
        name: "RaidOverviewComp",
        components: {ListRaidComp},
        data: () => ({
            raids: [] as userRaid[],
            anmeldungen: [] as any[]
        }),
        methods: {
            anmeldung: function(raid: any): any {
                if (this.anmeldungen) {
                    const anmeldung = this.anmeldungen.find(a => a.raid === raid.id);
                    return anmeldung;
                }
            }
        },
        created: async function() {
            this.raids = await _raids.listForPlayer();
            this.anmeldungen = await _raids.getAnmeldungState();
        }
    })
